(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/hooks/use-products-hook.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/hooks/use-products-hook.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const logger = svs.arena.logger;
const {
  useState,
  useCallback
} = React;
const {
  fetchProducts
} = svs.arena.store.teams.actions;
let isFetchingData = false;

const useProducts = () => {
  const dispatch = ReactRedux.useDispatch();
  const [statusState, setStatusState] = useState({
    isSuccess: false,
    isLoading: false
  });

  const {
    loadingError,
    products
  } = ReactRedux.useSelector(state => {
    var _state$teams;
    return (_state$teams = state.teams) === null || _state$teams === void 0 ? void 0 : _state$teams.products;
  }) || {};
  const fetchData = useCallback(async () => {
    if (isFetchingData) {
      return;
    }
    isFetchingData = true;
    logger.debug('useProductsHook: fetching new data (products) from server');
    setStatusState(prevState => _objectSpread(_objectSpread({}, prevState), {}, {
      isLoading: true
    }));
    const fetchData = await dispatch(fetchProducts());
    setStatusState({
      isSuccess: RTK.isFulfilled(fetchData),
      isLoading: false
    });
    isFetchingData = false;
  }, [dispatch]);
  React.useEffect(() => {
    if (!products) {
      fetchData();
    }
  }, [fetchData, products]);
  return {
    data: products,
    isLoading: statusState.isLoading,
    isSuccess: statusState.isSuccess,
    error: loadingError
  };
};
svs.arena.shared.hooks.useProducts = useProducts;

 })(window);